import { ScopeViz } from './styles/ScopeViz'
import { BarsViz } from './styles/BarsViz'
import { OrbViz } from './styles/OrbViz'
import { RadialViz } from './styles/RadialViz'

// The catalog of speech-visualizer styles. The key is what gets persisted (a
// future per-character / per-story author choice); `Component` renders the
// canvas given { character, color }. Adding a style = one entry here.
export const VIZ_STYLES = [
  { key: 'scope', label: 'Oscilloscope', Component: ScopeViz },
  { key: 'bars', label: 'Spectrum bars', Component: BarsViz },
  { key: 'orb', label: 'Reactive orb', Component: OrbViz },
  { key: 'radial', label: 'Radial burst', Component: RadialViz },
]

export const VIZ_BY_KEY = Object.fromEntries(VIZ_STYLES.map((s) => [s.key, s]))

export const DEFAULT_VIZ_STYLE = 'bars'

// Resolve a (possibly unknown / legacy) style key to a real style entry.
export function resolveVizStyle(key) {
  return VIZ_BY_KEY[key] || VIZ_BY_KEY[DEFAULT_VIZ_STYLE]
}
